import Vue from "vue"
import VueRouter from "vue-router"
import axios from "axios"

import * as i18n from "./i18n"
import App from "./App"
import NotFound from "./views/NotFound"

axios.defaults.timeout = 10 * 1000

Vue.config.ignoredElements = [/^yt-/]

const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: () => import("./layout"),
      children: [
        { path: "", name: "home", component: () => import("./views/Home") },
        {
          path: "stylegen",
          name: "stylegen",
          component: () => import("./views/StyleGenerator"),
        },
      ],
    },
    {
      path: "/room/test",
      name: "test_room",
      component: () => import("./views/Room"),
      props: route => ({ strConfig: route.query }),
    },
    {
      path: "/room/chat",
      name: "room",
      component: () => import("./views/Room"),
      props(route) {
        const roomKeyType = 1
        const roomKeyValue = '1'
        return { roomKeyType, roomKeyValue, strConfig: route.query }
      },
    },
    {
      path: "/room/queue",
      name: "queue",
      component: () => import("./views/Queue")
    },
    { path: "*", component: NotFound },
  ],
})

new Vue({
  render: h => h(App),
  router,
  i18n: i18n.i18n,
}).$mount("#app")
